"use client"

import { setWalletTrackingParameters } from "@opensea/analytics"
import { useRouter } from "@opensea/navigation"
import { useOnChange } from "@opensea/ui-kit/hooks"
import { BigNumber } from "@opensea/utils"
import { useAccount, useBalances } from "@opensea/wallet"
import { useEffect } from "react"
import { useConnectedAccountServerHint } from "@/hooks/use-connected-account-server-hint"
import { identify } from "@/lib/integrations/identify"

/**
 * Identify a user when we know who they are.
 */
export const useWalletTracking = () => {
  const { address, connectorId, chainId, authenticated } = useAccount()
  const [_, setServerHint] = useConnectedAccountServerHint()
  const router = useRouter()
  const { balances, loading: loadingBalances } = useBalances()

  useEffect(() => {
    identify(address)
    setServerHint(address ?? "")
  }, [address, setServerHint])

  useOnChange(address, () => {
    router.refresh()
  })

  useEffect(() => {
    setWalletTrackingParameters({
      chainId,
      web3Wallet: connectorId,
      totalUsdBalance: loadingBalances
        ? undefined
        : BigNumber.sum(...balances.map(b => b.usdValue)).toNumber(),
      balanceByChain: loadingBalances
        ? undefined
        : balances.reduce<Record<string, number>>((acc, b) => {
            const currentTotal = acc[b.currency.chainIdentifier] ?? 0
            acc[b.currency.chainIdentifier] = currentTotal + Number(b.usdValue)
            return acc
          }, {}),
      authenticated,
    })
  }, [chainId, connectorId, balances, loadingBalances, authenticated])
}
